import React, { useState, useEffect } from 'react';

const CalendarEventItem = (props) => {
    const [activityStatus, setActivityStatus] = useState(props.item.isComplete ? "completed " : props.item.isUnlocked ? "unlocked" : "locked");

    useEffect(() => {
        setActivityStatus(props.item.isComplete ? "completed " : props.item.isUnlocked ? "unlocked" : "locked");
    }, [props.item.isUnlocked]);

    const getDateTime = (item) => {
        const date = new Date(item + "Z");
      //  let year = date.getFullYear();
        let month = date.getMonth();
        let dt = date.getDate();

        if (dt < 10) {
            dt = '0' + dt;
        }
        if (month < 10) {
            month = '0' + month;
        }

        const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const sortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        // var strTime = hours + ':' + minutes + ' ' + ampm;
        var strTime = hours + ' ' + ampm;

        return {
            date: dt + " " + sortNames[parseInt(month)],
            time: strTime,
            activityCompletedOn: month + '/' + dt + ' at ' + hours + ':' + minutes + ' ' + ampm.toUpperCase()
        };
    };

    return (
        <>
            <div className="event-item event-wrapper">
                <div className="date-holder">
                    <div className="date">
                        {getDateTime(props.item.activityStartDate).date}
                    </div>
                    <div className="time">
                        {getDateTime(props.item.activityStartDate).time} {props.item.timezone}
                    </div>

                    <div className={"event-status " + activityStatus}></div>
                </div>
                <div className="content-holder">
                    <div className="event-content">
                        {props.item.activityName}
                    </div>
                </div>
            </div>
        </ >
    );
};

export default CalendarEventItem;